// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"31fe7cc9","239":"bc4814da","453":"c1eda9f0","732":"67720f6d"}[chunkId] + ".chunk.js";
};